import { Button } from '../ui/button'
import { Users, FileText, ToggleLeft, ToggleRight } from 'lucide-react'
import { ViewMode } from '../../types'

interface CrewModeToggleProps {
  currentMode: ViewMode
  onModeChange: (mode: ViewMode) => void
  className?: string
}

export function CrewModeToggle({ currentMode, onModeChange, className = '' }: CrewModeToggleProps) {
  const isCrewMode = currentMode === 'crew'

  const handleToggle = () => {
    const newMode: ViewMode = isCrewMode ? 'full' : 'crew'
    onModeChange(newMode)
  }

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      <div className="flex items-center space-x-2">
        <FileText className={`h-4 w-4 ${!isCrewMode ? 'text-blue-600' : 'text-gray-400'}`} />
        <span className={`text-sm font-medium ${!isCrewMode ? 'text-blue-600' : 'text-gray-500'}`}>
          Full Plan
        </span>
      </div>
      
      <Button
        variant="ghost"
        size="sm"
        onClick={handleToggle}
        className="p-1 h-8 w-12 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors"
        aria-label={`Switch to ${isCrewMode ? 'full plan' : 'crew'} view`}
      >
        {isCrewMode ? (
          <ToggleRight className="h-5 w-5 text-blue-600 ml-1" />
        ) : (
          <ToggleLeft className="h-5 w-5 text-gray-500" />
        )}
      </Button>
      
      <div className="flex items-center space-x-2">
        <Users className={`h-4 w-4 ${isCrewMode ? 'text-blue-600' : 'text-gray-400'}`} />
        <span className={`text-sm font-medium ${isCrewMode ? 'text-blue-600' : 'text-gray-500'}`}>
          Crew View
        </span>
      </div>
    </div>
  )
}

interface CrewModeButtonProps {
  currentMode: ViewMode
  onModeChange: (mode: ViewMode) => void
  className?: string
}

// Alternative button-style toggle for mobile
export function CrewModeButton({ currentMode, onModeChange, className = '' }: CrewModeButtonProps) {
  const isCrewMode = currentMode === 'crew'

  const handleToggle = () => {
    const newMode: ViewMode = isCrewMode ? 'full' : 'crew'
    onModeChange(newMode)
  }

  return (
    <Button
      variant={isCrewMode ? "default" : "outline"}
      size="sm"
      onClick={handleToggle}
      className={`flex items-center space-x-2 ${className}`}
    >
      {isCrewMode ? (
        <>
          <Users className="h-4 w-4" />
          <span>Crew View</span>
        </>
      ) : (
        <>
          <FileText className="h-4 w-4" />
          <span>Full Plan</span>
        </>
      )}
    </Button>
  )
}